import { cn } from '@dreamstack/util/src/cn'
import type { FunctionComponent } from 'react'

export const ShareContactWrapper: FunctionComponent<
  React.PropsWithChildren<{
    canShare: boolean
    isProperty: boolean
    className?: string
  }>
> = ({ canShare, isProperty, className, children }) => {
  return (
    <div
      className={cn(
        'col-span-full flex flex-col-reverse justify-center space-y-px-32 mt-px-24 md:flex-row md:col-start-10 md:col-span-2 md:space-y-0 md:space-x-px-32 md:mt-0 ml:space-x-px-48 lg:col-start-9 lg:justify-start lg:mt-px-64',
        canShare && 'mt-0 md:mt-px-40',
        isProperty && 'md:mt-px-24 lg:mt-px-64',
        isProperty && canShare && 'md:mt-px-48',
        className
      )}
    >
      {children}
    </div>
  )
}
